import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum FactorFormPurchaseOrderLineItemKeys {
  itemNumber = 'itemNumber',
  sku = 'sku',
  itemDescription = 'itemDescription',
  orderSize = 'orderSize',
  orderUnit = 'orderUnit',
  agreedPrice = 'agreedPrice',
  caseSize = 'caseSize',
  caseUnit = 'caseUnit',
  orderQty = 'orderQty',
  lineTotal = 'lineTotal',
}

const purchaseOrderLineItemSchema = yup.object().shape({
  itemNumber: yup.number().nullable().optional(),
  sku: yup.string().nullable().optional(),
  itemDescription: yup.string().nullable().optional(),
  orderSize: yup.string().nullable().optional(),
  orderUnit: yup.string().nullable().optional(),
  agreedPrice: yup.string().nullable().optional(),
  caseSize: yup.string().nullable().optional(),
  caseUnit: yup.string().nullable().optional(),
  orderQty: yup.string().nullable().optional(),
})

export const factorFormPurchaseOrderAddressInfoSchema = yup.object().shape({
  companyName: yup.string().nullable().optional(),
  addressLine1: yup.string().nullable().optional(),
  addressLine2: yup.string().nullable().optional(),
  city: yup.string().nullable().optional(),
  state: yup.string().nullable().optional(),
  zipCode: yup.string().nullable().optional(),
  country: yup.string().nullable().optional(),
})
export type FactorFormPurchaseOrderAddressInfo = yup.InferType<
  typeof factorFormPurchaseOrderAddressInfoSchema
>

export const factorFormPurchaseOrderFileDataSchema = yup.object().shape({
  poNumber: yup.string().nullable().optional(),
  lastEditedDate: yup.string().nullable().optional(),
  from: factorFormPurchaseOrderAddressInfoSchema,
  supplier: factorFormPurchaseOrderAddressInfoSchema,
  shipTo: factorFormPurchaseOrderAddressInfoSchema,
  week: yup.string().nullable().optional(),
  orderDate: yup.string().nullable().optional(),
  shipMethod: yup.string().nullable().optional(),
  pickupDate: yup.string().nullable().optional(),
  pickupTimeFrom: yup.string().nullable().optional(),
  pickupTimeTo: yup.string().nullable().optional(),
  deliveryDate: yup.string().nullable().optional(),
  deliveryTimeFrom: yup.string().nullable().optional(),
  deliveryTimeTo: yup.string().nullable().optional(),
  items: yup.array().of(purchaseOrderLineItemSchema).required(),
  items2: yup.array().of(purchaseOrderLineItemSchema).optional(),
})

export type FactorFormPurchaseOrderFileData = yup.InferType<
  typeof factorFormPurchaseOrderFileDataSchema
>

type RequiredFileData = MakeRequiredAndNullable<FactorFormPurchaseOrderFileData>

export const factorFormPurchaseOrderFileMappings: RequiredFileData = {
  poNumber: 'c09d2430-659d-4b96-9200-11c5780d0cf8',
  lastEditedDate: 'a44ab26e-07ce-4ec0-91de-b6dd21347d27',
  from: {
    companyName: '73780019-2d29-4fea-8008-c6ffa67fd6a6',
    addressLine1: '40a89159-e830-472d-b79a-8665bdefe6bf',
    addressLine2: '19d3cdef-07e2-4e03-9f2a-c30ebfbdb28b',
    city: 'db125d07-2e3e-43f8-804c-55e8af61d32a',
    state: 'c70f178a-cb35-4c8a-bc0d-46b0515b4a01',
    zipCode: '82065d17-0152-46d2-bb35-eafe6bb400d4',
    country: '79bd7c21-7531-4977-bfa6-c9e628bc4722',
  },
  supplier: {
    companyName: '82de33bf-379b-4be5-8f0f-6a8d5a9939a9',
    addressLine1: '98462d78-5877-4c67-9d7e-7446e518ba5c',
    addressLine2: '63d859cd-a4ab-4b73-96dc-fcfad2284779',
    city: 'ff394366-5ef5-4d13-9436-b550ff7fd52f',
    state: '0ede928f-e948-43f6-bddf-90a5cf161025',
    zipCode: '05063617-a97c-408c-81c6-be817a99511d',
    country: '2a2a0599-ace9-449a-8235-d78707a37722',
  },
  shipTo: {
    companyName: 'cbeca810-0df6-470e-80ec-d769221e8961',
    addressLine1: 'f561c0c9-3997-4eb5-ac7e-dbc0c3d5e9b9',
    addressLine2: 'b9bd23a6-2d62-4323-a432-1200c5379d19',
    city: '59fe5cbc-3628-4bf3-9bb8-4a66d2e7db88',
    state: '174db517-ccf9-47fa-9471-6fa69687d6c1',
    zipCode: '8c225c9b-8ebc-4c79-93cb-a0b85030728b',
    country: '54797f0d-00f0-4fd3-ab8f-906a15206d08',
  },
  week: 'dbf3c26a-a2c3-464d-aa9a-a4269e865da2',
  orderDate: '4342b212-a8a8-4e40-beba-08f12dbd1262',
  shipMethod: 'e889cbb8-a377-4468-ae20-d485142fa86e',
  pickupDate: 'e1b981da-e980-401a-93dd-4be4d4bfbc0e',
  pickupTimeFrom: '6e25c251-27b5-47b4-b5c4-4278eb0ce5c0',
  pickupTimeTo: 'ec11e4e5-5abb-48e3-8629-a76f432d8b54',
  deliveryDate: '8a03d127-54de-407b-a735-d5bd037ad144',
  deliveryTimeFrom: 'ee8daf12-626f-4c9b-befe-6dbb31bdd3e6',
  deliveryTimeTo: '039df2b1-565e-4dc7-a1bb-9c2f46d83e31',
  items: [
    {
      itemNumber: null,
      sku: 'd8791103-7346-4e32-a500-3fbe996c0c04',
      itemDescription: '61c01d39-b454-426d-ba9c-decfd82aa5e1',
      orderSize: '12fa6f86-6697-4baa-8f99-3e687f7edc7d',
      orderUnit: '680caf5d-5f57-4892-85b8-972e7ddb676b',
      agreedPrice: '38dd87f6-abe2-4036-bf6d-2b90f1381b85',
      caseSize: '64018682-656b-4223-bc8e-7ebadcddb857',
      caseUnit: 'd779a24d-9ef1-4954-b62a-2fed30932e5b',
      orderQty: 'cd7f1f3f-8b87-4c35-9f71-9a50221fd745',
    },
  ],
  items2: [
    {
      itemNumber: null,
      sku: '3278a1e5-34cc-4afc-ab31-a7ae5947bd4b',
      itemDescription: '48b8fc83-4c06-40ce-b7f2-b51893e79870',
      orderSize: '2d2dc5fd-dae7-408e-a2dd-51661c182a12',
      orderUnit: '2b244a61-c56b-4d8f-b253-805d79da0ad1',
      agreedPrice: '3bba1ced-aa48-4e9c-9b0b-ca46fe6fb7c9',
      caseSize: '30362c58-8b27-4e3d-8c05-47dccc9199fc',
      caseUnit: '548518fa-2fa9-404d-9cb3-1fbd04b54840',
      orderQty: '2e5de2df-1a97-4b09-a41a-3a626a4339a9',
    },
  ],
}
